import type { PaginationProps } from "antd";
import { Pagination } from "antd";

import { goToTop } from "utils/helpers/screenOperations";
import "./PaginationComponent.scss";

const PaginationComponent = ({
  current,
  totalItems,
  pageSize,
  hasNextPage,
  changePageSize,
  changePage,
}: any) => {
  const onChange: PaginationProps["onChange"] = (page, size) => {
    // changePageSize(size);
    changePage(page);
    goToTop();
  };

  const showTotal: PaginationProps["showTotal"] = (total) => (
    <label>Ukupno {total}</label>
  );

  // if (totalItems <= pageSize) {
  //   return <></>;
  // }

  return (
    <div className="Pagination">
      <Pagination
        className="custom-pagination"
        current={current}
        total={totalItems}
        pageSize={pageSize}
        // defaultPageSize={12}
        // pageSizeOptions={["12", "24", "48", "96"]}
        showSizeChanger={false}
        // showQuickJumper
        // locale={{ jump_to: "Idi na", page: "Stranicu" }}
        showTotal={showTotal}
        onChange={onChange}
      />
      {/* Page size */}
      {/* <label>Veličina stranice:</label> */}
      <select
        value={String(pageSize)}
        onChange={(e) => changePageSize(e.target.value)}
        className="Page-Changer"
      >
        {[12, 24, 48, 96].map((n) => (
          <option key={n} value={String(n)}>
            {n}
          </option>
        ))}
      </select>
    </div>
  );
};

export default PaginationComponent;
